"use client";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  CartItem,
  addItem,
  clearCart,
  removeItem,
  selectCartItems,
} from "@/redux/features/cartSlice";
import Image from "next/image";
import add_to_cart_with_blue_background from "@/assets/images/logo/add_to_cart_with_blue_background..svg";
import { ToastOptions } from "@/utils/enum";
import BuyButton from "./BuyButton";
import {
  selectVivaCartItems,
  clearVivaCart,
  addVivaItem,
  removeVivaItem,
} from "@/redux/features/vivaCartSlice";
import { Modal, Button } from "react-bootstrap";
import Loader from "../Loader/Loader";
import { mapToVivaCartItem } from "@/utils/utils";
import { BsFillCartCheckFill } from "react-icons/bs";

const HandleCart = ({ item, v3 }: any) => {
  const Cart1 = useSelector(selectCartItems);
  const vivaCart = useSelector(selectVivaCartItems);
  const [cartLength, setCartLength] = useState(0);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingItem, setPendingItem] = useState<CartItem | null>(null);
  const [loading, setLoading] = useState(false);
  const [showCart1ClearModal, setShowCart1ClearModal] = useState(false);

  const router = useRouter();
  const dispatch = useDispatch();

  const handleRemoveFromCart = (data: CartItem) => {
    // Dispatch the removeItem action with the item's ID
    dispatch(removeItem({ data, persist: false }));
  };

  const handleAddToCart = (data: CartItem) => {
    const eventDateStr = data?.attributes?.event_register_start_date;
    const eventEndStr = data?.attributes?.event_register_end_date;
    const eventStartDate = new Date(eventDateStr)
      .setHours(0, 0, 0, 0)
      .valueOf();
    const eventEndDate = new Date(eventEndStr)
      .setHours(23, 59, 59, 999)
      .valueOf();

    const now = new Date().getTime();

    if (vivaCart.length > 0) {
      setPendingItem(data);
      setShowConfirmModal(true);
      return false;
    }

    if (eventStartDate < now && now < eventEndDate) {
      dispatch(addItem({ data, persist: false }));
      return true;
    } else {
      toast.error(
        eventStartDate > now
          ? "Event Registration is not started yet."
          : "Sorry, you missed the deadline for registration. Explore our other events!",
        ToastOptions,
      );
      return false;
    }
  };

  const handleAddToV3Cart = (rawData: any) => {
    const data = mapToVivaCartItem(rawData);

    if (!data.group_name) {
      console.warn("group_name missing in mapped data", data);
      return false;
    }

    if (Cart1.length > 0) {
      setPendingItem(data);
      setShowCart1ClearModal(true);
      return false;
    }

    dispatch(addVivaItem({ data, persist: true }));
    return true;
  };

  const handleConfirmClearCart1 = () => {
    if (pendingItem) {
      dispatch(clearCart());
      toast.success("Cleared cart items", ToastOptions);
      dispatch(addVivaItem({ data: pendingItem, persist: true }));
    }
    setShowCart1ClearModal(false);
    setPendingItem(null);
  };

  const handleCancelClearCart1 = () => {
    setShowCart1ClearModal(false);
    setPendingItem(null);
  };

  const handleConfirmClearVivaCart = () => {
    if (pendingItem) {
      dispatch(clearVivaCart());
      localStorage.removeItem("formData");
      toast.success("Cleared version 3 cart items", ToastOptions);
      handleAddToCart(pendingItem);
    }
    setShowConfirmModal(false);
    setPendingItem(null);
  };

  const handleCancelClearVivaCart = () => {
    setShowConfirmModal(false);
    setPendingItem(null);
  };
  const handleRemoveFromV3Cart = (data: any) => {
    dispatch(
      removeVivaItem({
        data,
        persist: false,
        strictRemove: false,
      }),
    );
  };
  const getCartQuantity = (cartArray: any[]) => {
    if (v3) {
      return (
        cartArray.find(
          (val) =>
            val?.group_name === item?.group_name &&
            val?.sub_type === item?.["Sub Type"] &&
            val?.category === item?.category,
        )?.inCart || 0
      );
    } else {
      return cartArray.find((val) => val.id === item.id)?.inCart || 0;
    }
  };

  useEffect(() => {
    console.log("🚀 ~ HandleCart ~ vivaCart:", vivaCart);
    const length = v3 ? getCartQuantity(vivaCart) : getCartQuantity(Cart1);
    setCartLength(length);
  }, [Cart1, vivaCart, v3, item.inCart]);

  const handleCartClick = async () => {
    if (v3) {
      // handleAddToV3Cart(item);
      router.push("/events");
    } else {
      handleAddToCart(item);
    }
  };

  const handleSubmit = () => {
    if (v3) {
      if (cartLength > 0) {
        router.push("/events");
      }
    } else {
      if (cartLength > 0 || handleAddToCart(item)) {
        router.push("/cart");
      }
    }
  };
  console.log(cartLength, "cartLength");

  return (
    <div
      className="icon-container d-flex flex-row justify-content-between gap-2"
      // style={{ display: "flex", flexDirection: "row", gap: "110px" }}
    >
      {loading && <Loader />}
      <BuyButton
        classNames="w-100"
        label="Register Now"
        onButtonClick={handleSubmit}
      />
      <div>
        {v3 ? (
          cartLength ? (
            <div
              onClick={() => handleRemoveFromV3Cart(item)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                height: "3.13rem",
                width: "3.13rem",
                backgroundColor: "#a2c4fc",
                cursor: "pointer",
              }}
            >
              <BsFillCartCheckFill />
            </div>
          ) : (
            <span
              className="d-inline-flex"
              data-toggle="tooltip"
              title="Add Participants"
            >
              <div
                className="hover-container"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "50%",
                  height: "3.13rem",
                  width: "3.13rem",
                  border: "2px solid #3F41D1",
                  backgroundColor: "white",
                  cursor: "pointer",
                }}
                onClick={handleCartClick}
              >
                <Image
                  src={add_to_cart_with_blue_background}
                  alt="Add to cart"
                />
              </div>
            </span>
          )
        ) : cartLength ? (
          <div className="quantity-controls d-flex align-items-center mt-2">
            <div
              onClick={() => handleRemoveFromCart(item)}
              style={{ cursor: "pointer", fontSize: "20px" }}
            >
              <i className="bi bi-dash-circle"></i>
            </div>
            <div className="px-1" style={{ fontSize: "24px" }}>
              {cartLength}
            </div>
            <button
              onClick={() => handleCartClick()}
              style={{ fontSize: "20px", cursor: "pointer" }}
            >
              <i className="bi bi-plus-circle"></i>
            </button>
          </div>
        ) : (
          <span
            className="d-inline-flex"
            data-toggle="tooltip"
            title="Add Participants"
          >
            <div
              className="hover-container d-flex justify-content-center align-items-center"
              style={{
                borderRadius: "50%",
                height: "3.13rem",
                width: "3.13rem",
                border: "2px solid #3F41D1",
                backgroundColor: "white",
                cursor: "pointer",
              }}
              onClick={handleCartClick}
            >
              <Image src={add_to_cart_with_blue_background} alt="" />
            </div>
          </span>
        )}
      </div>

      {showConfirmModal && (
        <Modal show={showConfirmModal} centered backdrop="static">
          <Modal.Header>
            <Modal.Title>Confirm Version 3 Cart Clearance</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Your cart contains version 3 (Viva) events. Adding this item
            requires clearing the version 3 cart. Do you want to proceed?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCancelClearVivaCart}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleConfirmClearVivaCart}>
              Yes, Clear Cart
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {showCart1ClearModal && (
        <Modal show={showCart1ClearModal} centered backdrop="static">
          <Modal.Header>
            <Modal.Title>Confirm Cart Clearance</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Your cart contains existing items. Adding this version 3 (Viva) item
            requires clearing your cart. Do you want to proceed?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCancelClearCart1}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleConfirmClearCart1}>
              Yes, Clear Cart
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default HandleCart;
